import Vue from 'vue';
import VueRouter from 'vue-router';
import {
  PageNotFound,
} from '@bizfly/shared';
import i18n from '../utils/i18n';

Vue.use(VueRouter);

export const routes = [
  {
    path: '/',
    redirect: { path: '/projects' },
    name: 'ListLayout',
    component: () => import('@/layout/ManageLayout'),
    children: [
      {
        path: 'projects',
        name: 'ProjectManage',
        component: () => import('@/views/project/ProjectManage'),
        meta: { title: i18n.t('iam.title.projectManage') },
      },
      {
        path: 'roles',
        name: 'RoleManage',
        component: () => import('@/views/role/RoleManage'),
        meta: { title: i18n.t('iam.title.roleManage') },
      },
      {
        path: 'users',
        name: 'UserManage',
        component: () => import('@/views/user/UserManage'),
        meta: { title: i18n.t('iam.title.userManage') },
      },
      {
        path: 'tags',
        name: 'TagManage',
        component: () => import('@/views/tag/index'),
        meta: { title: i18n.t('iam.tag.title') },
      },
    ],
  },
  {
    path: '/',
    name: 'IntroLayout',
    component: () => import('@/layout/IntroLayout'),
    children: [
      {
        path: 'intro',
        name: 'Intro',
        component: () => import('@/views/intro/index.vue'),
        meta: { title: i18n.t('iam.intro.meta') },
      },
    ],
  },
  {
    path: '/detail/project/:idProject',
    name: 'DetailProjectLayout',
    component: () => import('@/layout/DetailProjectLayout'),
    children: [
      {
        path: 'users',
        name: 'ProjectUsers',
        component: () => import('@/views/project/detail/Users'),
        meta: { title: i18n.t('iam.title.users') },
      },
      {
        path: 'info',
        name: 'ProjectInfo',
        component: () => import('@/views/project/detail/Info'),
        meta: { title: i18n.t('iam.title.detailInfo') },
      },
      {
        path: 'delete',
        name: 'ProjectDelete',
        component: () => import('@/views/project/detail/Delete'),
        meta: { title: i18n.t('iam.title.projectDelete') },
      },
      {
        path: 'leave',
        name: 'ProjectLeave',
        component: () => import('@/views/project/detail/Leave'),
        meta: { title: i18n.t('iam.title.projectLeave') },
      },
    ],
  },
  {
    path: '/detail/role/:idRole/project/:projectId',
    redirect: { path: '/detail/role/:idRole/project:/projectId/info' },
    name: 'DetailRoleLayout',
    component: () => import('@/layout/DetailRoleLayout'),
    children: [
      {
        path: 'info',
        name: 'RoleInfo',
        component: () => import('@/views/role/detail/Info'),
        meta: { title: i18n.t('iam.title.detailInfo') },
      },
      {
        path: 'delete',
        name: 'RoleDelete',
        component: () => import('@/views/role/detail/Delete'),
        meta: { title: i18n.t('iam.title.roleDelete') },
      },
    ],
  },
  {
    path: '/detail/project/:idProject/user/:idUser',
    redirect: { path: 'detail/project/:idProject/user/:idUser/info' },
    name: 'DetailUserLayout',
    component: () => import('@/layout/DetailUserLayout'),
    children: [
      {
        path: 'info',
        name: 'UserInfo',
        component: () => import('@/views/user/detail/Info'),
        meta: { title: i18n.t('iam.title.detailInfo') },
      },
      {
        path: 'delete',
        name: 'UserDelete',
        component: () => import('@/views/user/detail/Delete'),
        meta: { title: i18n.t('iam.title.userDelete') },
      },
    ],
  },
  {
    path: '/create',
    name: 'CreateLayout',
    component: () => import('@/layout/CreateLayout'),
    children: [
      {
        path: 'project',
        name: 'CreateProject',
        component: () => import('@/views/project/create/Project'),
        meta: { title: i18n.t('iam.title.createProject') },
      },
      {
        path: 'role',
        name: 'CreateRole',
        component: () => import('@/views/role/create/Role'),
        meta: { title: i18n.t('iam.title.createRole') },
      },
      {
        path: 'user',
        name: 'CreateUser',
        component: () => import('@/views/user/create/User'),
        meta: { title: i18n.t('iam.title.createUser') },
      },
      {
        path: 'tag',
        name: 'CreateTag',
        component: () => import('@/views/tag/create'),
        meta: { title: i18n.t('iam.tag.create') },
      },
    ],
  },
  {
    path: '/update/project/:idProject',
    name: 'UpdateProjectLayout',
    component: () => import('@/layout/CreateLayout'),
    children: [
      {
        path: '/',
        name: 'UpdateProject',
        component: () => import('@/views/project/create/Project'),
        meta: { title: i18n.t('iam.title.updateProject') },
      },
    ],
  },
  {
    path: '/update/role/:idRole/project/:projectId',
    name: 'CreateLayout',
    component: () => import('@/layout/CreateLayout'),
    children: [
      {
        path: '/',
        name: 'UpdateRole',
        component: () => import('@/views/role/create/Role'),
        meta: { title: i18n.t('iam.title.updateRole') },
      },
    ],
  },
  {
    path: '/update/project/:idProject/user/:idUser',
    name: 'UpdateUserLayout',
    component: () => import('@/layout/CreateLayout'),
    children: [
      {
        path: '/',
        name: 'UpdateUser',
        component: () => import('@/views/user/create/User'),
        meta: { title: i18n.t('iam.title.updateUser') },
      },
    ],
  },
  {
    path: '/user/:idUser',
    name: 'UserGlobal',
    component: () => import('@/layout/DetailUserGlobalLayout'),
    children: [
      {
        path: '/',
        name: 'UserGlobal',
        component: () => import('@/views/user/UserGlobal'),
        meta: { title: i18n.t('iam.title.userInfo') },
      },
    ],
  },
  {
    path: '/update/tag/:tagId/project/:projectId',
    component: () => import('@/layout/CreateLayout'),
    children: [
      {
        path: '/',
        name: 'UpdateTag',
        component: () => import('@/views/tag/create'),
        meta: { title: i18n.t('iam.tag.update') },
      },
    ],
  },
  {
    path: '/invite',
    name: 'NoticeLayout',
    component: () => import('@/layout/NoticeLayout'),
    children: [
      {
        path: 'success',
        name: 'InviteSuccess',
        component: () => import('@/views/notice/Success.vue'),
        meta: { title: i18n.t('iam.title.noticeSuccess') },
      },
      {
        path: 'error',
        name: 'InviteError',
        component: () => import('@/views/notice/Error.vue'),
        meta: { title: i18n.t('iam.title.noticeError') },
      },
      {
        path: '/',
        name: 'Invite',
        component: () => import('@/views/notice/VerifyEmail.vue'),
        meta: { title: i18n.t('iam.title.checkVerify') },
      },
    ],
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: {
      title: '404',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/iam',
  routes,
});

export default router;
